
import { useEffect } from '../../common/common';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation';

const MidSettings = (type) => {
    const { navigateDashboard } = Navigations();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    // const [isLoading, setisLoading] = useState(false);
    useEffect(() => {
        const logUserData = () => {
            if (users?.length > 0) {
                const userTypes = users[0]['UserType'];
                const usertypeArray = typeof userTypes === 'string' ?
                    userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

                const hasOne = usertypeArray.includes(1);
                const hasTwo = usertypeArray.includes(2);

                if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasTwo)) {
                    // Seller logic
                } 
                else if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne)) {
                    // Seller logic
                } 
                
                else {
                    navigateDashboard('buyer');
                }
            }
        };

        if (Array.isArray(users) && users.length > 0) {
            logUserData();
        }
    }, [users, type, navigateDashboard]);
    return { users,userPlan,Remainuser,subUser }
}

export default MidSettings